import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import { useImagesLoaded } from '../../hooks/useImagesLoaded';
import { useShareablesTemplateRoot } from '../../hooks/useShareablesTemplateRoot';

const useStyles = makeStyles((theme)=> ({
    wrap: {
        position: 'relative',
        width: '100%',
        height: '100%',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        boxSizing: 'border-box',
    },
    watermark: {
        position: 'absolute',
        left: '50%',
        bottom: '30%',
        zIndex: 9999,

        '& img': {
            position: 'relative',
            left: '-50%',
        },
    }
}));

export default function DailyShareable(props) {
    const {
        rootClasses,
        parsedData,
        onImagesLoaded,
    } = useShareablesTemplateRoot(props);
    const classes = Object.assign({}, rootClasses, useStyles(props));
    const {
        shareable_image_url,
        watermark = false,
    } = parsedData || {};
    const loadedBgs = useImagesLoaded([shareable_image_url]);

    useEffect(() => {
        if(loadedBgs && !window.isLoaded) {
            if(typeof onImagesLoaded === 'function') {
                onImagesLoaded();
            } else {
                window.isLoaded = true;
            }
        }
    }, [loadedBgs, onImagesLoaded]);

    if(!parsedData) return null;
    if(!shareable_image_url) return null;

    return (
        <>
            <div className={classes.root} id="templateRoot">
                <div className={classes.viewport}>
                    <div className={classes.wrap}
                        style={{
                            backgroundImage: `url("${shareable_image_url}")`,
                        }}
                    >
                        {watermark && (<div className={classes.watermark}>
                            <img src="./images/watermark-stamp.svg" alt="Watermark" />
                        </div>)}
                    </div>
                </div>
            </div>
        </>
    );
}
